import { render, staticRenderFns } from "./UserOrg.vue?vue&type=template&id=3c70c435&"
import script from "./UserOrg.vue?vue&type=script&lang=js&"
export * from "./UserOrg.vue?vue&type=script&lang=js&"
import style0 from "./UserOrg.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c70c435')) {
      api.createRecord('3c70c435', component.options)
    } else {
      api.reload('3c70c435', component.options)
    }
    module.hot.accept("./UserOrg.vue?vue&type=template&id=3c70c435&", function () {
      api.rerender('3c70c435', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/System/User/UserOrg.vue"
export default component.exports